interface Config {
  AUTH_APP_URL: string,
  APP_URL: string,
  AUTH_API_URL: string
}

const config : Config = {
  AUTH_APP_URL: process.env.REACT_APP_AUTH_APP_URL || "",
  APP_URL: process.env.REACT_APP_APP_URL || "",
  AUTH_API_URL: process.env.REACT_APP_AUTH_SERVER_URL || ""
};

export default config;
